module.exports = __webpack_public_path__ + "static/media/onboarding.06916af7.jpg";